import { render, staticRenderFns } from "./soldout-logo.mpx?vue&type=template&id=65d87834&scoped=true&component=true&componentId=soldout-logo3eb8d8a0"
import script from "./soldout-logo.mpx?vue&type=script&lang=js&component=true&componentId=soldout-logo3eb8d8a0"
export * from "./soldout-logo.mpx?vue&type=script&lang=js&component=true&componentId=soldout-logo3eb8d8a0"
import style0 from "./soldout-logo.mpx?vue&type=style&index=0&id=65d87834&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m3eb8d8a0%22%7D&component=true&componentId=soldout-logo3eb8d8a0"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d87834",
  null
  
)

export default component.exports